import { useEffect, useState } from 'react';
import fetchEloquaURLs from '../../../services/fetchEloquaURLs';
import appConstants from '../../../constants';

function extractSearchedExpertisesFromSearchCriteria(searchCriteria) {
  let searchedExpertises = '';
  if(!!searchCriteria && !!searchCriteria.length) {
    let expertises = [];
    searchCriteria.forEach((sc) => {
      const isExpertise = sc[appConstants.KEY_TYPE] === appConstants.VALUE_PARTNER_SPECIALIZATION ||
                          sc[appConstants.KEY_TYPE] === appConstants.VALUE_CISCO_POWERED_SERVICE
      if (isExpertise) {
        expertises.push(sc.name);
      }
    });
    searchedExpertises = expertises.join(',');
  }
  return searchedExpertises;
}

export default function useEloquaURLs(partnerBeGeoId, searchCriteria) {

  const [isEloquaURLGenerationInProgress, setIsEloquaURLGenerationInProgress] = useState(false);
  const [eloquaURLGenerationErrors, setEloquaURLGenerationErrors] = useState(null);
  const [eloquaUrls, setEloquaUrls] = useState(null);

  useEffect(
    () => {
      async function loadEloquaURLs() {
        const loadedEloquaURLs = await fetchEloquaURLs(partnerBeGeoId, extractSearchedExpertisesFromSearchCriteria(searchCriteria));

        if(!loadedEloquaURLs.hasError) {
          setEloquaURLGenerationErrors(null);
          setEloquaUrls(previousValue => loadedEloquaURLs.fetchedEloquaURLs);
        }
        else {
          setEloquaURLGenerationErrors(loadedEloquaURLs.errorMessage);
          setEloquaUrls(previousValue => loadedEloquaURLs.fetchedEloquaURLs);
        }
        setIsEloquaURLGenerationInProgress(false);
      }

      if(!!partnerBeGeoId) {
        setIsEloquaURLGenerationInProgress(true);
        loadEloquaURLs();
      }

    },
    [partnerBeGeoId]
  );

  return { isEloquaURLGenerationInProgress, eloquaURLGenerationErrors, eloquaUrls }
}
